<script setup lang="ts">
import { useShowDialogStore } from '@/stores/modules/dialog'
import { useUserInfoStore } from '@/stores/modules/user'
import { ref } from 'vue'

const showDialogStore = useShowDialogStore()
const userStore = useUserInfoStore()

const password = ref('')

const lockScreen = () => {
  showDialogStore.showLockDialog = false
  userStore.lockInfo.isLockScreen = true
  userStore.lockInfo.password = password.value
}
</script>
<template>
  <div>
    <el-dialog
      class="lock-dialog"
      v-model="showDialogStore.showLockDialog"
      title="锁定屏幕"
      width="500"
      :close-on-click-modal="false"
    >
      <div class="user-info">
        <!-- 头像 -->
        <el-avatar class="mr-1" :size="80" :src="userStore.avatar" />
        <span class="my-1"> {{ userStore.user.username }}</span>
      </div>
      <el-input
        class="px-4 mb-4"
        type="password"
        v-model="password"
        placeholder="请输入密码"
        clearable
        show-password
      >
        <template #prefix>
          <el-icon>
            <lock />
          </el-icon>
        </template>
      </el-input>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" class="lock-button" @click="lockScreen"> 锁定 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<style scoped lang="scss">
:deep(.lock-dialog) {
  @apply rounded-lg;
}
.user-info {
  @apply flex flex-col justify-center items-center my-4;
}
.dialog-footer {
  @apply px-4 mb-4;
}
.lock-button {
  @apply w-full;
}
</style>
